import { CoreActionTypes, SetFontLoadedAction } from '../types';

export const setFontLoadedAction = (
  identifier: string,
  supportedGlyphs: RegExp
): SetFontLoadedAction => ({
  type: CoreActionTypes.SET_FONT_LOADED,
  identifier,
  supportedGlyphs,
});
